module.exports = __webpack_public_path__ + "img/V_Pay.325fd2c9.svg";